import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";

const withModal = WrappedComponent => {
  // eslint-disable-next-line react/display-name
  class Wrapped extends React.Component {
    componentDidMount() {
      document.addEventListener("keydown", this.handleEsc, false);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleEsc, false);
    }

    handleEsc = event => {
      if (event.keyCode === 27) {
        this.goBack();
      }
    };

    getParentUrl = () => {
      const { match } = this.props;
      return (match && `/${match.params[0]}`) || "/policies";
    };

    goBack = () => {
      const { history } = this.props;
      history.push(this.getParentUrl());
    };

    render() {
      return (
        <WrappedComponent {...this.props} parentUrl={this.getParentUrl()} />
      );
    }
  }
  Wrapped.propTypes = {
    match: ReactRouterPropTypes.match.isRequired,
    history: ReactRouterPropTypes.history.isRequired
  };
  return Wrapped;
};

export default withModal;
